import { render, staticRenderFns } from "./wxConfirmOrder.vue?vue&type=template&id=cdd6b87e&scoped=true&lang=pug&"
import script from "./wxConfirmOrder.vue?vue&type=script&lang=js&"
export * from "./wxConfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./wxConfirmOrder.vue?vue&type=style&index=0&id=cdd6b87e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd6b87e",
  null
  
)

export default component.exports